import React from 'react'

const FormLangBar = ({currentLangList,formLang,setFormLang}) => {

    return (
        <>
            <div className='flex gap-2 justify-end text-xs'>
                { currentLangList.map((lang) => (
                    <button  
                        onClick={()=>setFormLang(lang.langCode)}
                        type="button"
                        className={`rounded-md px-3 py-1.5 transition ${formLang === lang.langCode ? 'text-white bg-indigo-600 font-semibold' : 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200'}`} 
                        key={lang.langCode}
                        >
                        {lang.langCode === 'ar' ? 'عربي' : lang.langCode === 'en' ? 'English' : (lang.langName || lang.langCode)}
                    </button>
                )) }
            </div>
        </>
    )
}

export default FormLangBar
